<template lang="pug">
  v-card.rounded-lg.elevation-4(style="overflow:hidden")
    v-card-text.pa-0(style="position:relative;")
      v-img(:src="imagen" height="160" contain)
      v-btn(@click="descargarArchivo(archivo)" style="position:absolute;bottom:12px;right:12px;padding:8px 10px 8px 10px;height:auto;" color="orange darken-1" dark).txtn
        | Descargar&nbsp;
        v-icon(size="16") fas fa-download
    v-divider
    v-card-text
      div(style="width:auto;")
        div(style="width:62px;height:62px;float:left;margin-right:15px").orange.darken-2
          p(style="font-size:10px;text-align:center;line-height:22px;").font-weight-medium.pa-0.ma-0.white--text {{ fecha.split("-")[1] }}
          p(style="font-size:24px;text-align:center;line-height:20px;").pa-0.ma-0.white--text.font-weight-bold {{ fecha.split("-")[0] }}
          p(style="font-size:13px;text-align:center;line-height:22px;").pa-0.ma-0.white--text {{ fecha.split("-")[2] }}
        h6.subtitle-1.blue--text.text--darken-2(style="text-align:justify;line-height:22px").mb-2.font-weight-medium
          v-chip(color="blue darken-2" small dark label style="margin-top:-5px;height:20px")
            | {{ tipo }}
          | &nbsp;{{ titulo }}
      p(style="text-align:justify;" v-html="description").pt-0.mb-0
</template>

<style lang="stylus">
.custom-new-img
  background-size 200px !important
</style>

<script>
export default {
  data: () => ({
    rotator: 0
  }),
  props: {
    reverse: Boolean,
    imagen: String,
    titulo: String,
    fecha: String,
    description: String,
    tipo: String,
    archivo: String
  },
  methods:{
    descargarArchivo(url){
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = url.replace(/^.*[\\\/]/, '')
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    }
  }
}
</script>
